var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgConfirmSubmissionConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ICN_Modal confirmare Confirma Depunerea_Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.58 2.002a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H4.006a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    fill: "#009a44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "ICN_Confirma Depunere_Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.218 33.555a13.472 13.472 0 00-3.451 0 5.257 5.257 0 00-4.666 5.234c-.008 5.1-.049 8.439 0 13.466.124 4.754 4.08 4.909 4.6 4.969 3.864 0 6-.023 9.959 0a4.679 4.679 0 005.028-4.271",
    "data-name": "Path 936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 65",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#009a44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.316 50.319H42.862c-.662 0-1.2-.538-1.2-1.2v-2.833c0-.661.538-1.2 1.2-1.2h2.087l.238-.354c1.223-1.825.943-3.897.58-5.155h.23l-.664-1.19a3.673 3.673 0 01-.459-1.787c0-1.914 1.442-3.471 3.215-3.471s3.215 1.557 3.215 3.47c0 .695-.19 1.364-.547 1.937l-.03.047-.022.05c-.364.814-1.424 3.658.22 6.1l.237.353h2.154c.662 0 1.2.539 1.2 1.2v2.833c0 .662-.538 1.2-1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.316 49.519a.4.4 0 00.4-.4v-2.833a.4.4 0 00-.4-.4h-1.728a1.6 1.6 0 01-1.327-.706c-1.873-2.785-.693-5.965-.286-6.873.03-.067.064-.132.103-.194a2.85 2.85 0 00.426-1.513c0-1.473-1.083-2.671-2.415-2.671s-2.415 1.198-2.415 2.67c0 .496.124.98.357 1.398a1.6 1.6 0 01.139.33c.399.937 1.515 4.116-.319 6.85a1.6 1.6 0 01-1.328.71h-1.661a.4.4 0 00-.4.4v2.832c0 .22.18.4.4.4h10.454m0 1.6H42.862a2 2 0 01-2-2v-2.833a2 2 0 012-2h1.66c1.637-2.44.096-5.51.096-5.51h.016a4.459 4.459 0 01-.56-2.176c0-2.361 1.798-4.271 4.015-4.271s4.015 1.912 4.015 4.27c0 .873-.246 1.685-.669 2.361-.31.693-1.266 3.217.153 5.326h1.728a2 2 0 012 2v2.833a2 2 0 01-2 2z",
    fill: "#fff"
  }))))));
}

export default SvgKpmgConfirmSubmissionConfirm;